function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Fragment } from "react";
import Filter from "../Filter";
import useData from "./data";
import Select from "react-select";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ListTitle = function ListTitle(_ref) {
  var addFilterHandlerNew = _ref.addFilterHandlerNew,
    config = _ref.config,
    isMapView = _ref.isMapView,
    onMapClick = _ref.onMapClick,
    onGridClick = _ref.onGridClick,
    winnreNoAuth = _ref.winnreNoAuth,
    onResetFilters = _ref.onResetFilters;
  var _useData = useData({
      winnreNoAuth: winnreNoAuth
    }),
    searchProjects = _useData.searchProjects;
  var history = useHistory();
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex justify-between border-b-[1.9px] py-6",
      children: [/*#__PURE__*/_jsx("div", {
        className: "w-[70%] lg:w-[40%]",
        children: /*#__PURE__*/_jsx(Select, {
          placeholder: "Search",
          options: searchProjects === null || searchProjects === void 0 ? void 0 : searchProjects.map(function (value) {
            return {
              label: value === null || value === void 0 ? void 0 : value.projectName,
              value: value === null || value === void 0 ? void 0 : value.id
            };
          }),
          onChange: function onChange(val) {
            history.push("/projects/detail?projectId=".concat(val.value));
          },
          styles: {
            container: function container(provided, state) {
              return _objectSpread(_objectSpread({}, provided), {}, {
                color: "black",
                width: "100%"
              });
            },
            control: function control(styles, state) {
              return _objectSpread(_objectSpread({}, styles), {}, {
                opacity: "0.95",
                height: "100%",
                color: "black",
                border: "1px solid #BFBFBF ",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #BFBFBF"
                },
                borderRadius: "10px"
              });
            },
            placeholder: function placeholder(styles) {
              return _objectSpread(_objectSpread({}, styles), {}, {
                color: "#000000B3",
                fontFamily: "inherit",
                fontWeight: 400
              });
            }
          },
          className: "text-grey-900 placeholder-[#000000B3] font-semibold ".concat(config !== null && config !== void 0 && config.darkMode ? "bg-black" : "".concat(config !== null && config !== void 0 && config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : "bg-white"), "  text-base text-left h-12\""),
          components: {
            DropdownIndicator: function DropdownIndicator() {
              return null;
            },
            IndicatorSeparator: function IndicatorSeparator() {
              return null;
            }
          }
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "w-[20%] flex lg:block items-center justify-center",
        children: /*#__PURE__*/_jsx(Filter, {
          addFilterHandlerNew: addFilterHandlerNew,
          isMapView: isMapView,
          onMapClick: onMapClick,
          onGridClick: onGridClick,
          config: config,
          winnreNoAuth: winnreNoAuth,
          onResetFilters: onResetFilters
        })
      })]
    })
  });
};
export default ListTitle;